"use strict";
// import imsrc from "../imsr-common.js";
import { ImsrApi } from "./imsrApi.js";

export class ImsrTenants {
  constructor() {
    this.imsrApi = new ImsrApi();
  }

  async getTenant(tenantId) {
    try {
      const params = {
        tenantId: tenantId,
      };
      return await this.imsrApi.doApi("get", "/tenants", params);
    } catch (e) {
      throw { status: e.status, message: e.message };
    }
  }
}

export default ImsrTenants;